import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function selfSetLimit(value: boolean): ValidatorFn {
    // TODO: remove control var later
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return (control: AbstractControl): ValidationErrors | null => {
        return { selfSetLimit: value };
    };
}
